import React from 'react';

import { ImageBadge } from 'components/core/ImageBadge';
import { Stars } from 'components/review/Stars';

import priceTag from 'assets/images/icons/icon-price-tag.svg';

import './GhostFacilityCard.scss';

export default function GhostFacilityCard() {
	return (
		<div className="ghost-facility-card">
			<div className="image-and-badge">
				<div className="facility-image-link" />
				<ImageBadge icon={priceTag} color="green" />
			</div>
			<div className="ghost-text" />
			<div className="ghost-text" />
			<div>
				<Stars
					className="ghost-stars"
					rating={5}
					size="small"
				/>
			</div>
		</div>
	);
}
